import { ElementPropertyRule } from '@fullstory/proto/fs/services/search-settings';
import { useMemo } from 'react';
import { PlatformSelector } from '@fullstory/proto/fs/api/segment';
import { useSelector } from 'react-redux';
import { namedElementsSelectors } from '@fullstory/redux';

const { getNamedElementsById } = namedElementsSelectors;

const EMPTY_PLATFORM_SELECTOR: PlatformSelector = { selector: '', platforms: [] };

export const useElementPropertyRuleSelectors = (elementPropertyRule: ElementPropertyRule) => {
  const namedElementsById = useSelector(getNamedElementsById);

  const namedElementSelectors = useMemo(
    () =>
      elementPropertyRule?.namedElementId !== undefined
        ? namedElementsById.get(elementPropertyRule.namedElementId)?.namedElement
            ?.platformSelectors ?? []
        : undefined,
    [elementPropertyRule?.namedElementId, namedElementsById],
  );
  const hasNamedElementSelectors = !!namedElementSelectors;
  const selectors: PlatformSelector[] | undefined = useMemo(
    () =>
      namedElementSelectors ??
      elementPropertyRule?.selectors?.selectors ??
      (elementPropertyRule?.any ? [EMPTY_PLATFORM_SELECTOR] : undefined),
    [namedElementSelectors, elementPropertyRule?.selectors?.selectors, elementPropertyRule?.any],
  );

  const childNamedElementSelectors = useMemo(
    () =>
      elementPropertyRule?.childNamedElementId !== undefined
        ? namedElementsById.get(elementPropertyRule.childNamedElementId)?.namedElement
            ?.platformSelectors ?? []
        : undefined,
    [elementPropertyRule?.childNamedElementId, namedElementsById],
  );
  const childSelectors: PlatformSelector[] | undefined = useMemo(
    () =>
      childNamedElementSelectors ??
      elementPropertyRule?.childSelectors?.selectors ??
      (elementPropertyRule?.anyChild ? [EMPTY_PLATFORM_SELECTOR] : undefined),
    [
      childNamedElementSelectors,
      elementPropertyRule?.childSelectors?.selectors,
      elementPropertyRule?.anyChild,
    ],
  );
  const hasChild = !!childSelectors;
  const hasChildAndNonEmptyParent = hasChild && !!selectors?.some(sel => !!sel.selector);

  return {
    selectors,
    childSelectors,
    hasNamedElementSelectors,
    hasChild,
    hasChildAndNonEmptyParent,
  };
};
